import baseUrl from "../Api/baseUrl";

export const useUpdateData = async (url, params) => {
  const config = {
    headers: {
      "content-type": "application/json",
      token: `${localStorage.getItem("token")}`,
    },
  };
  const res = await baseUrl.put(url, params, config);
  return res;
};

export const useUpdateDataWithImage = async (url, params) => {
  const config = {
    headers: { "content-type": "multipart/form-data", token: `${localStorage.getItem("token")}` },

    onUploadProgress: ({ loaded, total }) => {
      const state = Math.round((loaded * 100) / total);
      console.log(state);
    },
  };
  const res = await baseUrl.patch(url, params, config);
  return res;
};
